import { render, staticRenderFns } from "./Transformer.vue?vue&type=template&id=ef25f120&scoped=true&"
import script from "./Transformer.vue?vue&type=script&lang=js&"
export * from "./Transformer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef25f120",
  null
  
)

export default component.exports